import React from "react";

import { Typography } from "@mui/material";

import SquareChip from "@/components/elements/Chips/SquareChip";
import { ListCard } from "@/components/Luna/features";
import useLesson from "@/contexts/useLesson";
import type { Example } from "@/types";
import { htmlContentStyles } from "@/utils/htmlContentStyle";
import { renderMathInHtml } from "@/utils/mathRenderer";

interface ExampleItemProps {
  example: Example;
  index: number;
  onApprove: (index: number) => void;
  onRegenerate: (index: number) => void;
  onOpenModal: (index: number) => void;
  onDelete: (index: number) => void;
  onEdit: (index: number) => void;
}

const ExampleItem: React.FC<ExampleItemProps> = ({
  example,
  index,
  onApprove,
  onRegenerate,
  onOpenModal,
  onDelete,
  onEdit,
}) => {
  const { lessonResourceState } = useLesson();

  const isRead = lessonResourceState?.readItems?.includes(example.id);

  return (
    <ListCard
      id={example.id}
      title={`Example ${index + 1}`}
      isApproved={example.isApproved}
      onApprove={onApprove}
      onRegenerate={onRegenerate}
      isGenerated={true}
      index={index}
      onDelete={onDelete}
      onEdit={() => onEdit(index)}
      onOpenModal={() => onOpenModal(index)}
      status={example.isApproved ? "sent" : "pending"}
      isRead={isRead}
      appearance="example"
      viewMoreLabel="View example"
    >
      <SquareChip
        label={example.concept}
        sx={{
          mb: 1,
        }}
      />

      <>
        <Typography
          component="div"
          variant="text13L"
          sx={{
            ...htmlContentStyles,
            fontSize: "13px",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            onOpenModal(index);
          }}
          dangerouslySetInnerHTML={{
            __html: renderMathInHtml(example.description),
          }}
        />
      </>
    </ListCard>
  );
};

export default ExampleItem;
